import script from "./NotificationSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationSnackbar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__